import { api } from 'lib/httpClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

async function fetchCompanyLastUpdate({ queryKey }) {
  const [, companyId, reportingId, firmId] = queryKey;
  const {
    data: { data },
  } = await api.get(`investor-reporting/company-last-update`, {
    params: { companyId, reportingId, firmId },
  });
  return data;
}

export function useReportingCompanyUpdate({
  params: { companyId, reportingId, firmId },
  enabled = true,
}: {
  params: { companyId?: string; reportingId?: string; firmId?: string };
  enabled?: boolean;
}) {
  const canQuery = !!companyId && !!reportingId && !!firmId;

  return useQuery({
    queryKey: ['reporting-company-last-update', companyId, reportingId, firmId],
    queryFn: fetchCompanyLastUpdate,
    enabled: enabled && canQuery,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
